/**
 * Copy for the custom-role marker (MKT-530). CS asked for company-built roles to
 * be called out wherever a role is listed or assigned, so a License Manager can
 * tell their own roles apart from MedScout's defaults.
 */
export const CUSTOM_ROLE_COPY = {
  /**
   * "Custom Role", not "Custom": beside a role name, a bare "Custom" reads as an
   * adjective on something unnamed. Saying the noun makes the chip legible on
   * its own.
   */
  label: 'Custom Role',
  tooltip:
    'A role built for your company, rather than one of MedScout’s standard roles.',
} as const;
